// extracted by mini-css-extract-plugin
module.exports = {"item":"SearchHints_item__1Kojc"};